// extracted by mini-css-extract-plugin
export default {"example":"Home_example__jfV8+","uploadLabel":"Home_uploadLabel__llG93"};